export default __webpack_public_path__ + "static/media/img_baseRattle_rose_p.486e3b51.jpg";